<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormDevice @submit="submit" :title="'Update Device'" :form="form" :mode="'edit'"></FormDevice>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormDevice from '@/views/admin/device/FormDevice'
import axios from 'axios'

export default {
  name: 'updatedevice',
  components: {
    FormDevice
  },  
  data () {
    return {
      form: {}
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    }
  },
  methods: {
    submit (form) {
      let scope = this; 

      form._id = scope.id;
      form.user = scope.$store.getters.currentUser.id

      axios.put(process.env.VUE_APP_API + '/device/' + form._id, form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/devices/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  created () {
    let scope = this;
    axios.get(process.env.VUE_APP_API + '/device/' + scope.id, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.form = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
